import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  boardState,
  BoardStatus,
  setStatus,
  setPurchaseIdForCancel
} from 'common/modules/app/board';
import { GlossaryState } from 'common/modules/app/glossaries';
import { Glossary } from 'common/utils/glossary';
import { AppState } from 'pages';
import { BeforeCancelBoard } from 'pages/board/components/BeforeCancelBoard';
import { loadCookie, SasCookieKeys } from 'common/utils/cookie-utils';
import { PlanInitialState } from 'common/modules/domain/plan';
import {
  deletePurchase,
  PurchaseInitialState
} from 'common/modules/domain/purchase';
import { FetchState, FetchStatus } from 'common/modules/app/fetch';
import { DELETE_PURCHASE_ID } from 'common/modules/domain/purchase';
import { UserInformation } from 'common/modules/domain/user';

/**
 * StoreのStateからComponentに渡すPropsへ
 */
const useStateProps = () => {
  const boardState = useSelector<AppState, boardState>(
    (state) => state.app.board
  );
  const planState = useSelector<AppState, PlanInitialState>(
    (state) => state.domain.plan
  );
  const purchaseState = useSelector<AppState, PurchaseInitialState>(
    (state) => state.domain.purchase
  );
  const glState = useSelector<AppState, GlossaryState>(
    (state) => state.app.glossaries
  );
  const fetchState = useSelector<AppState, FetchState>(
    (state) => state.app.fetch
  );
  const userState = useSelector<AppState, UserInformation>(
    (state) => state.domain.user
  );
  const targetPurchase =
    purchaseState.purchasePlanList[boardState.selectedPurchaseIdForCancel];
  const fetchProcess = fetchState[DELETE_PURCHASE_ID];
  const isDeletePurchaseProcessing =
    fetchProcess !== null && fetchProcess === FetchStatus.PROCESSING;

  return {
    isDisplay: boardState.status === BoardStatus.BEFORE_CANCEL_DISP,
    targetPurchase: targetPurchase,
    purchase: purchaseState,
    fetchProcess: fetchProcess,
    user: userState,
    glossary: Glossary.instance(glState),
    isProcessing: isDeletePurchaseProcessing
  };
};

type SelectedState = ReturnType<typeof useStateProps>;
// Actionをdispatchする関数からComponentに渡すPropsへ
const useMargeProps = (state: SelectedState) => {
  const dispatch = useDispatch();

  /** クローズボタンの押下処理 */
  const onClickClose = () => {
    dispatch(setPurchaseIdForCancel(''));
    dispatch(setStatus(BoardStatus.NOT_DISP));
  };

  /** "解約する"の押下処理 */
  const onClickCancelPurchase = async () => {
    if (state.fetchProcess !== FetchStatus.PROCESSING) {
      const cookie = loadCookie();
      await dispatch(
        deletePurchase(
          cookie[SasCookieKeys.KEY_TOKEN],
          cookie[SasCookieKeys.KEY_REFRESH_TOKEN],
          state.targetPurchase.plan.price.payment,
          state.targetPurchase.purchaseId,
          state.user.language
        )
      );
      // 確認画面を閉じる
      dispatch(setStatus(BoardStatus.NOT_DISP));
    }
  };

  return {
    onClickClose: onClickClose,
    onClickCancelPurchase: onClickCancelPurchase
  };
};

/**
 * 購入確認画面全体のContainer Component
 */
export default function ContainerComponent() {
  const _props = { ...useStateProps(), ...useMargeProps(useStateProps()) };
  return <BeforeCancelBoard {..._props} />;
}
